export default {
  data() {
    return {
      items_per_page: 10
    }
  },
  created() {
    this.items_per_page = parseInt(localStorage.getItem(this.$options.name + "_items_per_page")) || 10
  },
  destroyed() {
    localStorage.setItem(this.$options.name + "_items_per_page", this.items_per_page)
  }
}
